export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-G-a6033f0584f2f4d47648c926daf5a0ff.jpg";